import * as React from "react";
import { blackColor } from "../../common/colors";
import IconIonicons from "react-native-vector-icons/Ionicons";
import Icon from "react-native-vector-icons/AntDesign";
import IconFontisto from "react-native-vector-icons/Fontisto";
export const iconLeft = () => (
  <Icon name="left" size={24} color={blackColor}></Icon>
);
export const iconSettings = () => (
  <IconIonicons
    name="md-settings-sharp"
    size={24}
    color={blackColor}
  ></IconIonicons>
);
export const iconRightList = () => (
  <Icon name="right" size={24} color={blackColor}></Icon>
);
export const iconRight = () => (
  <IconFontisto
    name="arrow-right-l"
    size={24}
    color={blackColor}
  ></IconFontisto>
);
